import React, { Fragment, useEffect } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { enhance } from './enhance';
import Loader from '../../common/Loader';
import PharmacyContent from './PharmacyContent';
import AppointmentHeader from '../Components/AppointmentHeader';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';
import useNavigateToPreviousPage from '../hooks/useNavigateToPreviousPage';

function AppointmentPharmacy({
  user,
  getUser,
  careUser,
  updateCareUser,
  setPreferredPharmacy,
}) {
  usePageView('Get Care | Preferred Pharmacy');

  const { navigateToPrevPage } = useNavigateToPreviousPage();

  useEffect(() => {
    getUser({ id: careUser.id });
  }, []);

  useEffect(() => {
    if (user.succeed) {
      const pharmacyId = get(user, 'primaryPatientProfile.pharmacy.id');
      updateCareUser(user);
      setPreferredPharmacy({ id: pharmacyId });
    }
  }, [user]);

  return (
    <Fragment>
      <MetaHelmet title="pages.title.getCare.pharm" />
      <AppointmentHeader
        handleBack={navigateToPrevPage}
        title="appointments.form.preferredPharmacy"
      />
      {user.sending ? <Loader /> : <PharmacyContent />}
    </Fragment>
  );
}

AppointmentPharmacy.propTypes = {
  user: PropTypes.object,
  getUser: PropTypes.func,
  careUser: PropTypes.object,
  consentsData: PropTypes.object,
  updateCareUser: PropTypes.func,
  setPreferredPharmacy: PropTypes.func,
};

export default enhance(AppointmentPharmacy);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentPharmacy/index.jsx